import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastService } from '../../shared/toast/toast.service';
import { AuthService } from '../auth.service';

const COUNTDOWN_SECONDS: number = 4;

@Component({
  selector: 'app-external-login-callback',
  templateUrl: './callback.component.html',
  standalone: false,
})
export class ExternalLoginCallbackComponent implements OnInit {
  constructor(
    private readonly authService: AuthService,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly toastService: ToastService,
  ) {}

  public async ngOnInit(): Promise<void> {
    try {
      await this.authService.getUser();
      this.router.navigate(['/']);
    } catch (error) {
      this.toastService.show('Une erreur est survenue lors de la connexion.', 'danger');
      this.router.navigate(['/login']);
    }
  }
}
